// import React, { useState, useMemo, useEffect } from "react";
// import "./DDReport.css";
// import { Link, Navigate, useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
// import axios from "axios";

// const accountsData = [
//   // RD/DD
//   {
//     sn: 1,
//     status: "Active",
//     mainType: "RD",
//     name: "Navin Kumar",
//     guardian: "Ramesh Kumar",
//     mobile: "9876543210",
//     aadhar: "123456789012",
//     approvalDate: "2023-01-01",
//     lastTransaction: "2023-08-01",
//     approvedBy: "Manager A",
//     balance: "₹40,000",
//     email: "navin@example.com",
//     nominee: "Rita Kumari",
//     setENach: "Yes",
//     nextDue: "2023-09-01",
//   },
//   {
//     sn: 2,
//     status: "Closed",
//     mainType: "DD",
//     name: "Monika Sharma",
//     guardian: "Naresh Sharma",
//     mobile: "7223456780",
//     aadhar: "456712349012",
//     approvalDate: "2024-06-15",
//     lastTransaction: "2024-12-01",
//     approvedBy: "Manager A",
//     balance: "₹15,000",
//     email: "monika@example.com",
//     nominee: "Mina Sharma",
//     setENach: "Yes",
//     nextDue: "2024-12-15",
//   },
//   // FD/MIS
//   {
//     sn: 1,
//     status: "Active",
//     mainType: "FD",
//     name: "Rajesh Singh",
//     guardian: "Suresh Singh",
//     mobile: "9876541110",
//     aadhar: "111122223333",
//     approvalDate: "2023-02-01",
//     lastTransaction: "2023-08-10",
//     approvedBy: "Manager C",
//     balance: "₹50,000",
//     email: "rajesh@example.com",
//     nominee: "Rita Singh",
//     setENach: "Yes",
//     nextDue: "2023-09-10",
//   },
//   {
//     sn: 2,
//     status: "Pre-Closed",
//     mainType: "MIS",
//     name: "Priya Sharma",
//     guardian: "Sunil Sharma",
//     mobile: "9123456781",
//     aadhar: "444455556666",
//     approvalDate: "2022-05-20",
//     lastTransaction: "2023-02-15",
//     approvedBy: "Manager D",
//     balance: "₹25,000",
//     email: "priya@example.com",
//     nominee: "Sonia Sharma",
//     setENach: "No",
//     nextDue: "2023-03-20",
//   },
// ];

// const mainTabsRD = ["RD Report", "DD Report"];
// const mainTabsFD = ["FD Report", "MIS Report"];
// const secondaryTabs = ["All", "Active", "Closed", "Pre-Closed", "Reject"];
// const rowsPerPage = 2;

// const ReportWithTabs = () => {
//   // // RD/DD state
//   // const [activeMainTab, setActiveMainTab] = useState("RD Report");
//   // const [activeSecondary, setActiveSecondary] = useState("All");
//   // const [currentPage, setCurrentPage] = useState(1);
//   // const [searchQuery, setSearchQuery] = useState("");
//   // const [selectedRow, setSelectedRow] = useState(null);
//   const navigate=useNavigate();
//   const dispatch=useDispatch();

//     const [activeMainTab, setActiveMainTab] = useState("FD");
//   const [activeSecondary, setActiveSecondary] = useState("All");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [accounts, setAccounts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const { profile } = useSelector((state) => state.userProfile);
  

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   // FD/MIS state
//   const [activeMainTabFD, setActiveMainTabFD] = useState("FD Report");
//   const [activeSecondaryFD, setActiveSecondaryFD] = useState("All");
//   const [currentPageFD, setCurrentPageFD] = useState(1);
//   const [searchQueryFD, setSearchQueryFD] = useState("");
//   const [selectedRowFD, setSelectedRowFD] = useState(null);


//    useEffect(() => {
//       dispatch(fetchUserProfile());
//     }, [dispatch]);
  
//     console.log(profile)
  
// // ================== FETCH ACCOUNTS ==================
// const fetchAccounts = async () => {
//   try {
//     setLoading(true);

//     const superAdminId = Number(profile?.superAdminId) || 14;
//     const branchId = Number(profile?.branchId) || Number(localStorage.getItem("userId")) || 56;
//     const createdBy = Number(localStorage.getItem("userId")) || 56;

//     const res = await axios.get(`https://narrowitsolution.in/api/fdmis/all`, {
//       params: {
//         superAdminId,
//         branchId,
//         createdBy,
//         page: currentPage,
//         limit: rowsPerPage,
//         accountType: activeMainTab,
//         status: activeSecondary !== "All" ? activeSecondary : undefined,
//         search: searchQuery || undefined,
//       },
//     });

//     console.log("FD Deposit List:", res.data);

//     if (res.data?.success) {
//       setAccounts(res.data.data || []);
//       setTotalPages(res.data.totalPages || 1);
//     } else {
//       setAccounts([]);
//     }
//   } catch (err) {
//     console.error("Error fetching deposit accounts:", err);
//     setAccounts([]);
//   } finally {
//     setLoading(false);
//   }
// };

// // Run when filters change
// useEffect(() => {
//   fetchAccounts();
// }, [activeMainTab, activeSecondary, searchQuery, currentPage]);



//   // // RD/DD filtered data
//   // const filteredData = useMemo(() => {
//   //   let data = accountsData.filter(
//   //     (item) =>
//   //       item.mainType === (activeMainTab === "RD Report" ? "RD" : "DD")
//   //   );
//   //   if (activeSecondary !== "All") {
//   //     data = data.filter((item) => item.status === activeSecondary);
//   //   }
//   //   if (searchQuery.trim()) {
//   //     data = data.filter((item) =>
//   //       Object.values(item)
//   //         .map((val) => (val ? val.toString() : ""))
//   //         .join(" ")
//   //         .toLowerCase()
//   //         .includes(searchQuery.toLowerCase())
//   //     );
//   //   }
//   //   return data;
//   // }, [activeMainTab, activeSecondary, searchQuery]);

//   // const paginatedData = filteredData.slice(
//   //   (currentPage - 1) * rowsPerPage,
//   //   currentPage * rowsPerPage
//   // );
//   // const totalPages = Math.ceil(filteredData.length / rowsPerPage);

//   // FD/MIS filtered data
//   const filteredDataFD = useMemo(() => {
//     let data = accountsData.filter(
//       (item) =>
//         item.mainType === (activeMainTabFD === "FD Report" ? "FD" : "MIS")
//     );
//     if (activeSecondaryFD !== "All") {
//       data = data.filter((item) => item.status === activeSecondaryFD);
//     }
//     if (searchQueryFD.trim()) {
//       data = data.filter((item) =>
//         Object.values(item)
//           .map((val) => (val ? val.toString() : ""))
//           .join(" ")
//           .toLowerCase()
//           .includes(searchQueryFD.toLowerCase())
//       );
//     }
//     return data;
//   }, [activeMainTabFD, activeSecondaryFD, searchQueryFD]);

//   const paginatedDataFD = filteredDataFD.slice(
//     (currentPageFD - 1) * rowsPerPage,
//     currentPageFD * rowsPerPage
//   );
//   const totalPagesFD = Math.ceil(filteredDataFD.length / rowsPerPage);

//   // Handlers
//   // const handleMainTabChange = (tab) => {
//   //   setActiveMainTab(tab);
//   //   setActiveSecondary("All");
//   //   setCurrentPage(1);
//   //   setSelectedRow(null);
//   // };
//   // const handleSecondaryChange = (tab) => {
//   //   setActiveSecondary(tab);
//   //   setCurrentPage(1);
//   //   setSelectedRow(null);
//   // };
//   const handleMainTabChangeFD = (tab) => {
//     setActiveMainTabFD(tab);
//     setActiveSecondaryFD("All");
//     setCurrentPageFD(1);
//     setSelectedRowFD(null);
//   };
//   const handleSecondaryChangeFD = (tab) => {
//     setActiveSecondaryFD(tab);
//     setCurrentPageFD(1);
//     setSelectedRowFD(null);
//   };

//   // // RD/DD Table
//   // const renderTableRDD = (data, activeSec, setSelectedRowFn) => (
//   //   <table className="DDFDReport-table">
//   //     <thead>
//   //       <tr>
//   //         <th>SN</th>
//   //         <th>Status</th>
//   //         <th>Name</th>
//   //         <th>Mobile</th>
//   //         {activeSec === "All" && (
//   //           <>
//   //             <th>Set eNach</th>
//   //             {/* <th>Guardian</th> */}
//   //             <th>Aadhar</th>
//   //             <th>Approval Date</th>
//   //             {/* <th>Approved By</th> */}
//   //             <th>Next Due</th>
//   //             <th>Share</th>
//   //             <th>Deposit Bond</th>
//   //           </>
//   //         )}
//   //         {activeSec !== "All" && <th>View</th>}
//   //       </tr>
//   //     </thead>
//   //     <tbody>
//   //       {data.length > 0 ? (
//   //         data.map((item) => (
//   //           <tr key={item.sn}>
//   //             <td>{item.sn}</td>
//   //             <td>{item.status}</td>
//   //             <td>{item.name}</td>
//   //             <td>{item.mobile}</td>
//   //             {activeSec === "All" ? (
//   //               <>
//   //                 <td>{item.setENach}</td>
//   //                 {/* <td>{item.guardian}</td> */}
//   //                 <td>{item.aadhar}</td>
//   //                 <td>{item.approvalDate}</td>
//   //                 {/* <td>{item.approvedBy}</td> */}
//   //                 <td>{item.nextDue}</td>
//   //                  <td style={{ textAlign: "center" }}>
//   //                 <button
//   //                   className="DDsharecerti-sub"
//   //                   onClick={() =>activeMainTab === "RD Report"?navigate("/Banking/Report/RDCertificates"):navigate("/Banking/Report/DDCertificates")}>
//   //                    Certificate
//   //                 </button>
//   //               </td>
//   //               <td style={{ textAlign: "center" }}>
//   //                 <button
//   //                   className="DDBond-sub"
//   //                   onClick={() =>
//   //                     alert(`Generating Share Certificate for ${item.name}`)
//   //                   }
//   //                 >
//   //                    Certificate
//   //                 </button>
//   //               </td>
//   //               </>
//   //             ) : (
//   //               <td>
//   //                 <button
//   //                   className="DDFDReportview-btn"
//   //                   onClick={() => setSelectedRowFn(item)}
//   //                 >
//   //                   View
//   //                 </button>
//   //               </td>
//   //             )}
//   //           </tr>
//   //         ))
//   //       ) : (
//   //         <tr>
//   //           <td colSpan="13" style={{ textAlign: "center" }}>No Data Found</td>
//   //         </tr>
//   //       )}
//   //     </tbody>
//   //   </table>
//   // );

//   // FD/MIS Table
//   const renderTableFDMIS = (data, activeSec, setSelectedRowFn) => (
//     <table className="DDFDReport-table">
//       <thead>
//         <tr>
//           <th>SN</th>
//           <th>Account Number</th>
//           <th>Customer Name</th>
//           <th>Account Type</th>
//           {activeSec === "All" && (
//             <>
//           <th>Installment Frequency</th>
//           <th>ROI</th>
//           <th>Tenure</th>
//           <th>Deposite Amount</th>
//           <th>Maturity Amount</th>
//           {
//             activeMainTab==="MIS" && <th>Monthly Interest</th>
//           }
//           <th>Status</th>
//           <th>Certificate</th>
//           <th>Deposit Bond</th>
//           {/* <th>Action</th> */}
//           </>
//           )}
//           {activeSec !== "All" && <th>View</th>}
//         </tr>
//       </thead>
//       <tbody>
//         {accounts.length > 0 ? (
//           accounts.map((acc,index) => (
//             <tr key={acc.id}>
//               <td>{index+1}</td>
//               <td>{acc.accountNumber||"N/A"}</td>
//               <td>{acc.customerName||"N/A"}</td>
//               <td>{acc.accountType}</td>
//               {activeSec === "All" ? (
//                 <>
//               <td>{acc.installmentFrequency||"N/A"}</td>
//               <td>{acc.roi}</td>
//               <td>{acc.tenureMonths}</td>
//               <td>{acc.depositAmount}</td>
//               <td>{acc.maturityAmount}</td>
//               {
//             activeMainTab==="MIS" && <td>{acc.monthlyInterest}</td>
//           }
//           <td>{acc.status}</td>
//               {/* <td>{acc.approvedBy}</td> */}
//               <td style={{ textAlign: "center" }}>
//                   <Link
//                   to={"/Banking/Report/FDCertificates"}
//                     className="FDsharecerti-sub"
//                     state={{ row: acc }}
//                     // onClick={() =>
//                     //   activeMainTabFD === "FD Report"?navigate("/Banking/Report/FDCertificates"):navigate("/Banking/Report/MisCertificates")
//                     // }
//                   >
//                      Open
//                   </Link>
//                 </td>
                
//                 <td style={{ textAlign: "center" }}>
//                   <button
//                     className="FDBond-sub"
//                     onClick={() =>
//                       alert(`Generating Deposit Bond Certificate for ${acc.name}`)
//                     }
//                   >
//                      Certificate
//                   </button>
//                 </td>
//               </>
//               ) : (
//                 <td>
//                   <button
//                     className="DDFDReportview-btn"
//                     onClick={() => setSelectedRowFn(acc)}
//                   >
//                     View
//                   </button>
//                 </td>
//               )}
//             </tr>
//           ))
//         ) : (
//           <tr>
//             <td colSpan="12" style={{ textAlign: "center" }}>No Data Found</td>
//           </tr>
//         )}
//       </tbody>
//     </table>
//   );

//   // PDF Render
//   const renderPDF = (selected, type) => (
//     selected && (
//       <div className="DDFDReportpdf-style-card">
//         <h3>Report Details</h3>
//         <table className="DDFDReportpdf-style-table">
//           <tbody>
//             <tr>
//               <td><strong>SN</strong></td>
//               <td>{selected.sn}</td>
//               {type === "FD" && (
//                 <>
//                   <td><strong>Account</strong></td>
//                   <td>{selected.mainType}</td>
//                 </>
//               )}
//             </tr>
//             <tr>
//               <td><strong>Status</strong></td>
//               <td>{selected.status}</td>
//               <td><strong>Name</strong></td>
//               <td>{selected.name}</td>
//             </tr>
//             <tr>
//               <td><strong>Guardian</strong></td>
//               <td>{selected.guardian}</td>
//               <td><strong>Mobile</strong></td>
//               <td>{selected.mobile}</td>
//             </tr>
//             <tr>
//               <td><strong>Aadhar</strong></td>
//               <td>{selected.aadhar}</td>
//               <td><strong>Approval Date</strong></td>
//               <td>{selected.approvalDate}</td>
//             </tr>
//             <tr>
//               <td><strong>Approved By</strong></td>
//               <td>{selected.approvedBy}</td>
//               {type === "RD" && (
//                 <>
//                   <td><strong>Next Due</strong></td>
//                   <td>{selected.nextDue}</td>
//                 </>
//               )}
//             </tr>
//           </tbody>
//         </table>
//       </div>
//     )
//   );

//   return (
//     <div>
//       {/* RD/DD Section
//       <div className="DDFDReport-container rd-dd-container">
//         <div className={`DDFDReport-main-tabs ${activeMainTab.includes("RD") ? "RD" : "DD"}`}>
//           {mainTabsRD.map((tab) => (
//             <button
//               key={tab}
//               className={`DDFDReport-main-btn ${activeMainTab === tab ? "active" : ""}`}
//               onClick={() => handleMainTabChange(tab)}
//             >
//               {tab}
//             </button>
//           ))}
//         </div>
//         <div className={`DDFDReport-secondary-tabs ${activeMainTab.includes("RD") ? "RD" : "DD"}`}>
//           {secondaryTabs.map((tab) => (
//             <button
//               key={tab}
//               className={`DDFDReport-secondary-btn ${activeSecondary === tab ? "active" : ""}`}
//               onClick={() => handleSecondaryChange(tab)}
//             >
//               {tab}
//             </button>
//           ))}
//         </div>
//         <div className="DDFDReportsearch-box">
//           <input
//             type="text"
//             placeholder="Search by any field..."
//             value={searchQuery}
//             onChange={(e) => {
//               setSearchQuery(e.target.value);
//               setCurrentPage(1);
//             }}
//           />
//         </div>
//         <div className="DDFDReporttable-container">
//           {renderTableRDD(paginatedData, activeSecondary, setSelectedRow)}
//         </div>
//         <div className="DDFDReportpagination">
//           <button onClick={() => setCurrentPage((p) => p - 1)} disabled={currentPage === 1}>Previous</button>
//           <span>Page {currentPage} of {totalPages || 1}</span>
//           <button onClick={() => setCurrentPage((p) => p + 1)} disabled={currentPage === totalPages || totalPages === 0}>Next</button>
//         </div>
//         {renderPDF(selectedRow, "RD")}
//       </div> */}

//       {/* FD/MIS Section */}
//       <div className="DDFDReport-containers fd-mis-container">
//         <div className={`DDFDReport-main-tabs ${activeMainTabFD.includes("FD") ? "FD" : "MIS"}`}>
//           {mainTabsFD.map((tab) => (
//             <button
//               key={tab}
//               className={`DDFDReport-main-btn ${activeMainTabFD === tab ? "active" : ""}`}
//               onClick={() => handleMainTabChangeFD(tab)}
//             >
//               {tab}
//             </button>
//           ))}
//         </div>
//         <div className={`DDFDReport-secondary-tabs ${activeMainTabFD.includes("FD") ? "FD" : "MIS"}`}>
//           {secondaryTabs.map((tab) => (
//             <button
//               key={tab}
//               className={`DDFDReport-secondary-btn ${activeSecondaryFD === tab ? "active" : ""}`}
//               onClick={() => handleSecondaryChangeFD(tab)}
//             >
//               {tab}
//             </button>
//           ))}
//         </div>
//         <div className="DDFDReportsearch-box">
//           <input
//             type="text"
//             placeholder="Search by any field..."
//             value={searchQueryFD}
//             onChange={(e) => {
//               setSearchQueryFD(e.target.value);
//               setCurrentPageFD(1);
//             }}
//           />
//         </div>
//         <div className="DDFDReporttable-container">
//           {renderTableFDMIS(paginatedDataFD, activeSecondaryFD, setSelectedRowFD)}
//         </div>
//         <div className="DDFDReportpagination">
//           <button onClick={() => setCurrentPageFD((p) => p - 1)} disabled={currentPageFD === 1}>Previous</button>
//           <span>Page {currentPageFD} of {totalPagesFD || 1}</span>
//           <button onClick={() => setCurrentPageFD((p) => p + 1)} disabled={currentPageFD === totalPagesFD || totalPagesFD === 0}>Next</button>
//         </div>
//         {renderPDF(selectedRowFD, "FD")}
//       </div>
//     </div>
//   );
// };

// export default ReportWithTabs;


import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import "./DDReport.css";
import { Link, useNavigate } from "react-router-dom";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { useSelector, useDispatch } from "react-redux";

const secondaryTabs = ["All", "Active", "Closed", "Pre-Closed", "Reject"];
const rowsPerPage = 10;

const RDReport = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [activeMainTab, setActiveMainTab] = useState("FD");
  const [activeSecondary, setActiveSecondary] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const { profile } = useSelector((state) => state.userProfile);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // ---------------------- EMI View Handler -----------------------
  const handleViewEmi = (account) => {
    navigate(`/Deposit/EmiDetails/${account.id}`, { state: { account } });
  };

  // ---------------- Fetch Profile on Load -------------------------
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // --------------------- FETCH ACCOUNTS ---------------------------
  const fetchAccounts = async () => {
    try {
      setLoading(true);

      const superAdminId = Number(profile?.superAdminId) || 14;
      const branchId =
        Number(profile?.branchId) ||
        Number(localStorage.getItem("userId")) ||
        56;

      const createdBy = Number(localStorage.getItem("userId")) || 56;

      const res = await axios.get(`https://narrowitsolution.in/api/fdmis/all-new`, {
        params: {
          superAdminId,
          branchId,
          createdBy,
          page: currentPage,
          limit: rowsPerPage,
          accountType: activeMainTab,
          status: activeSecondary !== "All" ? activeSecondary : undefined,
          search: searchQuery || undefined,
        },
      });

      console.log("FD/MIS Deposit List:", res.data);

      if (res.data?.success) {
        setAccounts(res.data.data || []);
        setTotalPages(res.data.totalPages || 1);
      } else {
        setAccounts([]);
      }
    } catch (err) {
      console.error("Error fetching deposit accounts:", err);
      setAccounts([]);
    } finally {
      setLoading(false);
    }
  };

  // Call when filters change
  useEffect(() => {
    fetchAccounts();
    // eslint-disable-next-line
  }, [activeMainTab, activeSecondary, searchQuery, currentPage, profile]);

  // Reset pagination when main filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [activeMainTab, activeSecondary]);

  // ===================== RENDER TABLE ============================
  const renderTable = useMemo(() => {
    if (loading) {
      return (
        <tr>
          <td colSpan={activeMainTab==="FD"?"11":"12"} style={{ textAlign: "center" }}>Loading...</td>
        </tr>
      );
    }

    if (!accounts.length) {
      return (
        <tr>
          <td colSpan={activeMainTab==="FD"?"11":"12"}  style={{ textAlign: "center" }}>No Data Found</td>
        </tr>
      );
    }

    return accounts.map((acc, index) => {
      const isPending = acc.status === "Pending";

      return (
        <tr key={acc.id}>
          {/* SN */}
          <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>

          {/* Account No */}
          <td>{acc?.accountNumber || acc?.accountNo || "--"}</td>

          {/* Customer Name */}
          <td>{acc?.customer?.fullName || "--"}</td>

          {/* Account Type */}
          <td>{acc?.accountType || "--"}</td>

          {/* ROI */}
          <td>{acc?.roi || "--"}%</td>

          {/* Tenure */}
          <td>{acc?.tenureMonths || acc?.tenure || "--"}</td>

          {/* Maturity Amount */}
          <td>₹{acc?.maturityAmount?.toLocaleString() || "--"}</td>

          {/* Maturity Date */}
          <td>{new Date(acc?.maturityDate).toLocaleDateString() || "--"}</td>

          {/* Total Interest */}
          <td>₹{acc?.totalInterest?.toLocaleString() || "--"}</td>
          {/* Monthly Interest (only for MIS) */}
          {activeMainTab === "MIS" && (
            <td>₹{acc?.monthlyInterest?.toLocaleString() || "--"}</td>
          )}


          {/* Certificate */}
          <td>
            <Link
                to={"/Banking/Report/FDCertificates"}
                className="rd-cirtificate-open-btn"
                state={{ row: acc }}
              >
                Open
              </Link>
            {/* {isPending ? (
              <span className="status-badge-not-approved">Not Approved</span>
            ) : (
              <Link
                to={"/Banking/Report/FDCertificates"}
                className="rd-cirtificate-open-btn"
                state={{ row: acc }}
              >
                Open
              </Link>
            )} */}
          </td>

          {/* Action */}
          {/* <td>
            {isPending ? (
              <span className="status-badge-not-approved">Not Approved</span>
            ) : (
              <button
                className="DDFDReportview-btn"
                onClick={() => handleViewEmi(acc)}
              >
                View
              </button>
            )}
          </td> */}
        </tr>
      );
    });
  }, [accounts, loading, currentPage]);

  return (
    <div className="DDFDReport-container">
      <h2 style={{ textAlign: "center", marginBottom: 10 }}>
        {activeMainTab} Account Report
      </h2>

      {/* Main Tabs */}
      <div className="DDFDReport-main-tabs">
        {["FD", "MIS"].map((tab) => (
          <button
            key={tab}
            className={`DDFDReport-main-btn ${activeMainTab === tab ? "active" : ""}`}
            onClick={() => setActiveMainTab(tab)}
          >
            {tab} Report
          </button>
        ))}
      </div>

      {/* Secondary Tabs */}
      <div className="DDFDReport-secondary-tabs">
        {secondaryTabs.map((tab) => (
          <button
            key={tab}
            className={`DDFDReport-secondary-btn ${
              activeSecondary === tab ? "active" : ""
            }`}
            onClick={() => setActiveSecondary(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Search */}
      <div className="DDFDReportsearch-box">
        <input
          type="text"
          placeholder="Search by Account No / Customer..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {/* Table */}
      <div className="DDFDReporttable-container">
        <table className="DDFDReport-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Account No</th>
              <th>Customer Name</th>
              <th>Account Type</th>
              <th>ROI</th>
              <th>Tenure</th>
              <th>Maturity Amount</th>
              <th>Maturity Date</th>
              <th>Total Interest</th>
              {activeMainTab === "MIS" && <th>Monthly Interest</th>}
              <th>Certificate</th>
              {/* <th>Action</th> */}
            </tr>
          </thead>
          <tbody>{renderTable}</tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="DDFDReportpagination">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          Previous
        </button>

        <span>Page {currentPage} of {totalPages}</span>

        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default RDReport;
